jQuery(document).ready(function($){
  $('#bx-slider').bxSlider({
    pagerCustom: '#bx-pager',
    controls: false,
    touchEnabled: false,
    auto: true,
    pause: 6000,
    speed: 1500
  });

  $('.media-carousel').bxSlider({
    mode: 'horizontal',
    wrapperClass: 'bx-wrapper bx-wrapper-carousel',
    captions: false,
    controls: true,
    pager: false,
    minSlides: 1,
    maxSlides: 3,
    moveSlides: 1,
    slideWidth: 210,
    auto: true,
    autoStart: false,
    pause: 6000
  });

  $('.popup-gallery').each(function () { // the containers for all your galleries
    $(this).find('a').magnificPopup({
      //delegate: 'a', // the selector for gallery item
      type: 'image',
      mainClass: 'mfp-with-zoom mfp-img-mobile',
      image: {
        verticalFit: true,
        titleSrc: function (item) {
          return item.el.attr('desc');
        }
      },
      gallery: {
        enabled: true
      },
      zoom: {
        enabled: true,
        duration: 300, // don't foget to change the duration also in CSS
        opener: function (element) {
          return element.find('img');
        }
      }
    });
  });

  $('.popup-img').magnificPopup({
    delegate: 'a',
    type: 'image',
    closeOnContentClick: false,
    closeBtnInside: false,
    mainClass: 'mfp-with-zoom mfp-img-mobile',
    image: {
      verticalFit: true,
      titleSrc: function (item) {
        var retVal = "";
        var title = item.el.attr('title');
        var alt = item.el.attr('desc');
        var capt = "";
        var capt = item.el.parent().parent().find("figcaption").text();

        if (capt != "") {
          retVal += capt;
        } else if (alt != "") {
          retVal += alt;
        } else if (title != "") {
          retVal += title;
        }

        return retVal;
      }
    },
    gallery: {
      enabled: true
    },
    zoom: {
      enabled: true,
      duration: 300, // don't foget to change the duration also in CSS
      opener: function (element) {
        return element.find('img');
      }
    }
  });

  $('.popup-img-nogal').magnificPopup({
    type: 'image',
    zoom: {
      enabled: true,
      duration: 300, // don't foget to change the duration also in CSS
      opener: function (element) {
        return element;
      }
    }
  });

  $('.fivepopup-img').magnificPopup({
    delegate: 'a',
    type: 'image',
    closeOnContentClick: false,
    closeBtnInside: false,
    mainClass: 'mfp-with-zoom mfp-img-mobile',
    image: {
      verticalFit: true,
      titleSrc: function (item) {
        var retVal = "";
        var title = item.el.attr('title');
        var alt = item.el.attr('desc');
        var capt = "";
        var capt = item.el.parent().parent().find("figcaption").text();

        if (capt != "" && capt != "undefined") {
          retVal += capt;
        } else if (alt != "") {
          retVal += alt;
        } else if (title != "") {
          retVal += title;
        }

        return retVal;
      }
    },
    gallery: {
      enabled: true
    },
    zoom: {
      enabled: true,
      duration: 300, // don't foget to change the duration also in CSS
      opener: function (element) {
        return element.find('img');
      }
    }
  });

  $(".fiveReadonTrigger").click(function () {
    var target = $(this).attr("id");
    target = target.replace("introtext", "fulltext");
    $("#" + target).css("display", "block");
    $(this).css("display", "none");
  });

  $(".collapseReadon").click(function () {
    var target = $(this).attr("id");
    target = target.replace("fulltext", "introtext");
    $("#" + target).css("display", "block");
    $(this).css("display", "none");
  });

  $("input[name=mod_cleverreach_email]")
    .focus(function () {
      $(".mod_cr_hidden_fld").show("blind");
    })
    .focusout(function () {
      if ($(this).val() === "") {
        $(".mod_cr_hidden_fld").hide("blind");
      }
    })
  ;
});
